import { Variant } from "../types/product"

const variantQuantity = document.querySelector('[data-variant-quantity]')?.innerHTML
const quantityJSON = JSON.parse(variantQuantity || '{}')

export function shippingEstimate(variant: Variant): string {
  if (quantityJSON[variant.id] > 0) {
    return '12-14'
    //   return '5-7'
  } else {
      return '12-14'
}
}

